if (!customElements.get('zone-finder')) {
  customElements.define(
    'zone-finder',
    class ZoneFinder extends HTMLElement {
      // Static property to cache the zipArray data
      static zipArrayCache = null;

      constructor() {
        super();

        // Store references to DOM elements
        this.inputZipCode = this.querySelector('input');
        this.zoneResult = this.querySelector('.js-zone-result');
        this.zoneShopButton = this.querySelector('.js-zone-shop');

        // Define collections mapping
        this.collections = {
          '03': '/collections/climate-zone-3',
          '04': '/collections/climate-zone-4',
          '5A': '/collections/climate-zone-5',
          '5B': '/collections/climate-zone-5',
          '6A': '/collections/climate-zone-6',
          '6B': '/collections/climate-zone-6',
          '7A': '/collections/climate-zone-7',
          '7B': '/collections/climate-zone-7',
          '8A': '/collections/climate-zone-8',
          '8B': '/collections/climate-zone-8',
          '9A': '/collections/climate-zone-9',
          '9B': '/collections/climate-zone-9',
          '10A': '/collections/climate-zone-10',
          '10B': '/collections/climate-zone-10',
          '11A': '/collections/climate-zone-11',
          '11B': '/collections/climate-zone-11',
        };

        // Bind event handlers
        this.findZone = this.findZone.bind(this);
        this.handleInputInteraction = this.handleInputInteraction.bind(this);
      }

      connectedCallback() {
        // Add event listeners
        this.addEventListener('submit', this.findZone);
        this.inputZipCode.addEventListener('focus', this.handleInputInteraction);
        this.inputZipCode.addEventListener('input', this.handleInputInteraction);
      }

      disconnectedCallback() {
        // Clean up event listeners
        this.removeEventListener('submit', this.findZone);
        this.inputZipCode.removeEventListener('focus', this.handleInputInteraction);
        this.inputZipCode.removeEventListener('input', this.handleInputInteraction);
      }

      async handleInputInteraction() {
        // Load data only if it hasn't been loaded yet
        if (!ZoneFinder.zipArrayCache) {
          await this.loadZoneData();
        }
      }

      async loadZoneData() {
        try {
          const url = this.dataset.zones;
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error('Failed to load zip data');
          }
          // Cache the data in the static property
          ZoneFinder.zipArrayCache = await response.json();
        } catch (error) {
          console.error(error);
        }
      }

      findZone(event) {
        event.preventDefault(); // Prevent default form submission

        const zipCodeInput = this.querySelector('input').value.trim(); // Trim whitespace
        const zipCode = zipCodeInput; // Treat zip code as a string to preserve leading zeros

        let error = null;
        let outputZone = null;
        let outputCollectionURL = null;

        // Validate zip code length and format
        if (zipCode.length !== 5 || !/^\d{5}$/.test(zipCode)) {
          error = 'Please enter a valid 5-digit zip code.';
        } else if (ZoneFinder.zipArrayCache && ZoneFinder.zipArrayCache[zipCode]) {
          // If the zip code exists in the cached zipArray, process the zones
          outputZone = `Zone: ${ZoneFinder.zipArrayCache[zipCode].zone}`;
          outputCollectionURL = this.collections[ZoneFinder.zipArrayCache[zipCode].zone];
        } else {
          error = 'No zone found';
        }

        // Log outputs or errors (for debugging)
        // if (error) {
        //   console.error(error);
        // } else {
        //   //console.log(outputZone, outputCollectionURL); // Log results
        // }

        // Update the DOM based on the results
        if (outputZone) {
          this.zoneResult.textContent = `${outputZone}`;
          if (outputCollectionURL) {
            this.zoneShopButton.textContent = `Shop My Climate ${outputZone}`;
            this.zoneShopButton.href = outputCollectionURL;
            this.zoneShopButton.removeAttribute('aria-disabled');
            this.zoneShopButton.removeAttribute('disabled');
          } else {
            this.zoneShopButton.textContent = `No Products in ${outputZone}`;
            this.zoneShopButton.href = '/collections/all';
            this.zoneShopButton.setAttribute('aria-disabled', true);
            this.zoneShopButton.setAttribute('disabled', true);
          }
        } else {
          this.zoneResult.textContent = `${error}`;
          this.zoneShopButton.textContent = `Shop My Climate Zone`;
          this.zoneShopButton.href = '/collections/all';
          this.zoneShopButton.setAttribute('aria-disabled', true);
          this.zoneShopButton.setAttribute('disabled', true);
        }
      }
    }
  );
}